import Loader from 'components/Loader';
import Logger from 'utilities/logger';
import getStorage from 'utilities/getStorage';
const logger = Logger('implicit_callback');
const newrelic = window.newrelic;

const REDIRECT_1099 =
  process.env.REACT_APP_ENVIRONMENT === 'prod'
    ? 'https://castandcrew.my.site.com/1099Services/login?so=00Di0000000aHzN'
    : 'https://castandcrew--uat.sandbox.my.site.com/1099services/login?so=00DOz0000000LIz';

const ImplicitCallback = () => {
  const storage = getStorage();
  newrelic?.addPageAction('userLoggedIn');
  logger.debug('Successfully logged in');
  const redirect1099 = storage.getItem('redirect1099');
  storage.removeItem('redirect1099');
  logger.debug(
    'Redirecting to',
    redirect1099 ? REDIRECT_1099 : window.location.origin,
  );
  window.location.replace(
    redirect1099 ? REDIRECT_1099 : window.location.origin,
  );
  return <Loader />;
};

export default ImplicitCallback;
